import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SearchIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
import { track } from '../../utils/analytics';
export function ClassicHero() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const onCta = (e: React.MouseEvent) => {
    e.preventDefault();
    track('hero_cta_click', {
      variant: 'classic'
    });
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-14 lg:pt-20 pb-16 lg:pb-24 overflow-hidden bg-gradient-to-b from-navy-50/60 to-white" data-id="element-716" data-mp="1wc4pg4vjwrn1">
      <div className="absolute inset-0 pointer-events-none" data-id="element-717" data-mp="1mg1ec9iq1iny">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-primary-100/25 blur-3xl hidden sm:block" data-id="element-718" data-mp="1mie2j4f2op9g" />
        <div className="absolute bottom-0 left-0 w-[380px] h-[380px] rounded-full bg-cyan-100/20 blur-3xl hidden sm:block" data-id="element-719" data-mp="b15vebd1kv1l" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-720" data-mp="niz0zq6pt59l">
        <div className="max-w-4xl" data-id="element-721" data-mp="ijcojiypnt1u">
          <motion.span initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold tracking-wide uppercase" data-id="element-722" data-mp="ik4i6o8qzgph">
            <SearchIcon className="w-3.5 h-3.5" data-id="element-723" data-mp="11hyqf021xo6t" />
            {c.hero.eyebrow}
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.08
        }} className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight leading-[1.1]" data-id="element-724" data-mp="1g6bnk0cvld2w">
            {c.hero.h1}
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} className="mt-5 text-base sm:text-lg text-navy-500 leading-relaxed max-w-3xl" data-id="element-725" data-mp="1k9huzbbq5aay">
            {c.hero.lead}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.24
        }} className="mt-8" data-id="element-726" data-mp="qu5mhcit0cq0">
            <a href="#contact" onClick={onCta} className="group inline-flex w-full sm:w-auto items-center justify-center gap-2 px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-500 rounded-xl hover:from-primary-700 hover:to-primary-600 transition-colors shadow-lg shadow-primary-600/25" data-id="element-727" data-mp="10ncqasxwbknz">
              {c.hero.cta}
              <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-728" data-mp="3cd5kdffbyrqw" />
            </a>
          </motion.div>
        </div>

        <motion.dl initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.32
      }} className="mt-12 lg:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-729" data-mp="38ug7cnjkpsmx">
          {c.hero.facts.map(f => <div key={f.label} className="p-5 rounded-2xl bg-white border border-navy-200 shadow-sm" data-id="element-730" data-mp="2v2rugi1i304w">
              <dt className="text-2xl sm:text-3xl font-extrabold text-navy-900" data-id="element-731" data-mp="3msmxtim70qck">
                {f.value}
              </dt>
              <dd className="mt-1 text-xs sm:text-sm text-navy-500" data-id="element-732" data-mp="3iqjhogokwxky">
                {f.label}
              </dd>
            </div>)}
        </motion.dl>
      </div>
    </section>;
}